import { adminCompanyArgs, adminFileAuth } from './adminAuth';
import { employeeToken } from './employeeAuth';
import { supabase } from './supabaseClient';
import { validateResume } from './peopleWorkflow';
export function recruitmentAdminAuth(company) { return adminCompanyArgs(company); }

export async function interviewAdmin(company, action, payload = {}) {
  const { data, error } = await supabase.rpc('recruitment_interview_admin', {...recruitmentAdminAuth(company), p_action: action, p_payload: payload});
  if (error) throw new Error(/function.*does not exist|schema cache/i.test(error.message) ? 'Interview setup is not installed yet. Apply the recruitment interview database migration.' : error.message);
  return data;
}
export async function interviewerCall(employee, action, payload = {}) {
  if (!employee?.id || !employee.session_token) throw new Error('Please sign in again before opening interviews.');
  const { data, error } = await supabase.rpc('recruitment_interviewer', {p_employee_id:employee.id,p_pin:employeeToken(employee),p_action:action,p_payload:payload});
  if (error) throw new Error(/function.*does not exist|schema cache/i.test(error.message) ? 'Interview setup is not available yet. Please contact HR.' : error.message);
  return data;
}
export async function uploadCandidateResume(company, candidateId, file) {
  const error = validateResume(file); if (error) throw new Error(error);
  const body = new FormData(); body.append('file',file); body.append('auth',JSON.stringify(await adminFileAuth(company))); body.append('candidate_id',candidateId);
  const response = await fetch('/api/recruitment-resume',{method:'POST',body});
  const result = await response.json().catch(()=>({error:'Resume service is unavailable.'}));
  if (!response.ok) throw new Error(result.error || 'Resume upload failed.');
  return result;
}
export async function openRecruitmentResume({ company, employee, candidateId, interviewId, download = false }) {
  // Reserve the window during the user gesture; credentials never appear in URLs.
  const preview = download ? null : window.open('about:blank','_blank');
  if (preview) preview.opener = null;
  try {
    const auth = employee ? { p_employee_id:employee.id,p_pin:employeeToken(employee) } : await adminFileAuth(company);
    const response = await fetch('/api/recruitment-resume',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({action:'download',auth,candidate_id:candidateId,interview_id:interviewId})});
    if (!response.ok) { const result=await response.json().catch(()=>({}));throw new Error(result.error||'Resume download failed.'); }
    const blob = await response.blob(); const url=URL.createObjectURL(blob);
    if (preview) preview.location.href=url;
    else { const link=document.createElement('a');link.href=url;link.download=decodeURIComponent(response.headers.get('X-Resume-Filename') || 'resume.pdf');link.click(); }
    setTimeout(()=>URL.revokeObjectURL(url),60000);
  } catch(error) { preview?.close();throw error; }
}
export async function convertJoinedCandidate(company, candidateId) {
  const { data,error }=await supabase.rpc('recruitment_convert_joined_candidate',{...recruitmentAdminAuth(company),p_candidate_id:String(candidateId)});
  if(error) throw new Error(error.message);
  return data;
}
